import { Observable, of } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

import { makeStateKey, StateKey, TransferState } from '@angular/core';

export class TranslateBrowserLoader implements TranslateLoader {
    public constructor(private transferState: TransferState) {}

    public getTranslation(lang: string): Observable<any> {
        const key: StateKey<Record<string, any> | null> = makeStateKey<Record<string, any> | null>(
            `transfer-translate-${lang}`,
        );
        const data: Record<string, any> | null = this.transferState.get(key, null);

        if (data) {
            return new Observable((observer) => {
                observer.next(data);
                observer.complete();
            });
        }

        // Return empty object — all translations are loaded via AngularI18nService.loadSectionAsync().
        // Fetching the base file here causes a race condition: ngx-translate's getTranslation()
        // overwrites this.translations[lang] when the async response arrives, destroying
        // any section translations already merged via setTranslation(..., true).
        return of({});
    }
}

export function translateBrowserLoaderFactory(
    transferState: TransferState,
): TranslateBrowserLoader {
    return new TranslateBrowserLoader(transferState);
}
